//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React from "react";

// import styles
import { NoDataStyles } from "./style";

// material-ui icons
import FolderOpenIcon from "@material-ui/icons/FolderOpen";
import { useTranslation } from 'react-i18next';

export default function NoData(props) {
  let { currentTab } = props;
  const classes = NoDataStyles();
  const { t } = useTranslation()

  // setting no data text switch case
  function setTab(tab) {
    switch (tab) {
      case "earned":
        return t("No transactions to display");
      case "redeemed":
        return t("No transactions to display");
      case "pending":
        return t("No transactions to display");
      case "pendingEarned":
        return t("No transactions to display");
      case "pendingRedeemed":
        return t("No transactions to display");
      case "redeem":
        return t("Billing account not found");
      default:
        return t("No Data Found");
    }
  }

  return (
    <React.Fragment>
      <div className={classes.emptyDataText}>
        <div>
          <FolderOpenIcon className={classes.emptyDataIcon} />{" "}
        </div>
        <div className={classes.errorMsg}>{setTab(currentTab)}</div>
      </div>
    </React.Fragment>
  );
}
